import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";

const modalStyle = {
  overflow: "hidden",
  position: "relative",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90vh",
  backgroundColor: "white",
  boxShadow: 24,
  pb: 2,
  borderRadius: "8px",
  ".close-pop-wrap": {
    top: "0px",
    right: "0px",
    position: "sticky",
    padding: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#112225",
  },
  ".CloseImg": {
    opacity: 1,
    cursor: "pointer",
    color: "#fff",
  },
};

const MembersOnlyModal = ({
  open,
  onClose,
  title = "Members Only",
  message = "Join to access this feature.",
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle} width="fit-content" maxWidth="600px" minWidth="350px">
        <Box className="close-pop-wrap">
          <Box className="Heading">
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "#fff", letterSpacing: "1px" }}
            >
              {title}
            </Typography>
          </Box>
          <CloseIcon onClick={onClose} className="CloseImg" />
        </Box>
        <Box className="ContentWrapper" sx={{ px: 3, py: 2 }}>
          <Typography sx={{ fontWeight: "bold", fontSize: "1rem", mb: 1 }}>
            {message}
          </Typography>
          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              component={Link}
              to="/plans"
              onClick={onClose}
              variant="contained"
              sx={{
                background: "#E29C2E",
                "&:hover": {
                  background: "#C07D1A",
                },
              }}
            >
              Subscribe Now
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default MembersOnlyModal;
